// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseCurrencyPage_inputContainer__3LNwX"};